import { ComponentType } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { RoleModel } from 'utils/role'

const Wrapper = styled.div`
  padding-top: 40px;
  padding-bottom: 24px;

  ${up('sm')} {
    padding-top: 88px;
    padding-bottom: 64px;
  }
`

const Suptitle = styled.h6`
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  color: #0078c9;
  line-height: 18px;

  ${up('sm')} {
    margin-bottom: 14px;
  }
`

const Title = styled.h1`
  font-weight: bold;
  font-size: 23px;
  line-height: 38px;

  ${up('sm')} {
    font-size: 26px;
    line-height: 33px;
  }
`

const Subtitle = styled.p`
  margin: 0;
  color: #22262a;
  font-size: 16px;
  line-height: 24px;

  ${up('sm')} {
    font-size: 17px;
    line-height: 26px;
  }
`

interface Props {
  role: RoleModel
}

export const Hero: ComponentType<Props> = ({ role }) => {
  const { formatMessage } = useIntl()

  return (
    <Wrapper>
      <Container>
        <Row>
          <Col>
            <Suptitle>
              <FormattedMessage id="explore.role.suptitle" values={{ role: formatMessage({ id: role.uuid }) }} />
            </Suptitle>
            <Title>
              <FormattedMessage id="explore.role.title" />
            </Title>
            <Subtitle>
              <FormattedMessage id="explore.role.subtitle" values={{ role: formatMessage({ id: role.uuid }) }} />
            </Subtitle>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}
